import { ReactElement } from 'react';

import { Address } from '@dreryk/address-common-api';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';
import { PatientAddressForm } from '../form/PatientAddressForm';

import { PatientAddressModalConfirmButton } from './PatientAddressModalConfirmButton';

type PatientAddressModalProps = {
   onClose: VoidFunction;
   patientId: number;
   patientAddress: Address | undefined;
};

export const PatientAddressModal = (props: PatientAddressModalProps): ReactElement => {
   return (
      <Modal
         testId={'patientAddress'}
         title={draftPrescriptionsTranslationKeys.fillPatientAddressData}
         width={ModalWidth.WIDE}
      >
         <PatientAddressForm patientAddress={props.patientAddress}>
            {({ formState, handleSubmit }) => (
               <>
                  <PatientAddressModalConfirmButton
                     patientId={props.patientId}
                     handleSubmit={handleSubmit}
                     onSuccess={props.onClose}
                  />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </PatientAddressForm>
      </Modal>
   );
};
